import Box                 from '@/components/box/Box';
import { Button }          from '@chakra-ui/react';
import { Text }            from '@chakra-ui/react';
import { useTranslation }  from 'react-i18next';

const CookieBox = () => {
	const { t } = useTranslation();

	const openCookiebot = () => {
		if (typeof window !== 'undefined' && window.Cookiebot) {
			window.Cookiebot.show();
		} else {
			console.warn(`Cookiebot n'est pas encore chargé.`);
		}
	};

	return (
		<Box>
			<Text className='poppins-semibold' fontSize="18px">{t('pages.settings.cookieBox.title')}</Text>
			<Text fontSize="14px">
				{t('pages.settings.cookieBox.description')}
			</Text>
			<Button
				marginTop="10px"
				textWrap="wrap"
				onClick={openCookiebot}
			>
				{t('pages.settings.cookieBox.button')}
			</Button>
		</Box>
	);
}

export default CookieBox;
